import VerifyPhonePage from "./verify.phone.page";

export default VerifyPhonePage;
